<template>
	<div>
		<div v-show="files.length > 0">
			<b-button @click="mode = 1">Lier des pdf à un master</b-button>
			<b-button @click='mode = 2; refresh()'>Déclarer un nouveau master</b-button>
		</div>

		<div v-show="mode == 1">
			Master
			<b-form-select v-model="load_name" :options="names"></b-form-select>
		</div>

		<div v-show="mode == 2">
			<br />
			<!-- <b-button @click='refresh'>Charger document</b-button><br /><br /> -->

			<div v-if="spinner" class="center_spinner">
				<fade-loader></fade-loader>
			</div>

			<b-form inline>
				<b-input-group style="width:300px" prepend="Nom">
					<b-form-input v-model="name"></b-form-input>
				</b-input-group>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_library" :disabled="!version || !name"><i class="fas fa-save"></i></b-button>
			</b-form>

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select v-model="load_name" :options="names"></v-select>
			</b-modal>

			<document_extraction_parameters_page v-show="Object.keys(documents).length > 0" ref="extract_page" />
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import store from "../store";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
	import treatments from "../services/treatments.js";
	import document_extraction_parameters_page from "../components/document_extraction_parameters_page.vue";

	var clone = require("clone");

	export default {
		name: "document_extraction_parameters",
		components: {
			FadeLoader,
			document_extraction_parameters_page
		},
		props: {
            files: {
                default: () => []
            },
		},
		data() {
			return {
				documents: {},
				spinner: false,
				type: "pdf_html",
				name: "",
				load_name: "",
				names: [],
				version: "1",
				id: uniqueId(),
				mode: 0
			};
		},
		watch: {
			load_name: {
				async handler() {
					if (this.load_name) 
						await this.load_library();
				},
			},
		},
		methods: {
			refresh()
			{
				this.$emit("refresh");
			},
			async save_library()
			{
				var data = this.save();

				await library.save(
					this.name,
					this.version,
					data,
					this.type,
					false,
					{},
					true 
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement effectué",
					type: "success"
				});
						
				this.$emit("button_start", true);
			},
			async load_library()
			{
				var data = await library.load(
					this.load_name,
					this.version,
					this.type
				);
				this.name = this.load_name;
				this.$refs.extract_page.load(data);				
				this.$emit("button_start", true);
			},
			async set_name()
			{
				var names = await library.getby_production(this.type, null, false, false, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
			get_data()
			{
				var data = this.$refs.extract_page.save();
				data.name = this.name;
				data.version = this.version;

				//console.log(data);

				return data;
			},
			load(data)
			{
				this.$refs.extract_page.load(data);
			},
			save()
			{
				var data = this.$refs.extract_page.save();
				data.name = this.name;
				data.version = this.version;

				//console.log(data)

				return data;
			},
			async setDocument(doc)
			{
				console.log(doc)

				this.spinner = true;

				var formData = new FormData();

				formData.append(doc.name, doc);

				var data = {
					action: "pdf_extract",
					parameters: {
						convert_json: true,
						convert_json_save_html_images: true,
						align: 1,
						rotate_90: true,
						rotate_180: true,
						rotate_270: true,
					},
				};

				Object.keys(data).forEach((key) =>
					formData.set(
						key,
						typeof data[key] === "object"
							? JSON.stringify(data[key])
							: data[key]
					)
				);

				var results = await workers.test(formData);

				//console.log(results);

				results = await treatments.getFileAlyx(results.data.files[0].url, false, false)

				//console.log(results)
			
				this.documents = {}
				this.documents[results.name] = results;
				var keys_pages = Object.keys(results.pages);
				for (var j = 0; j < keys_pages.length; j++) 
				{
					if (j == 0) {
						this.documents[results.name].url_pdf = results.pages[keys_pages[j]].url_pdf;
						this.$refs.extract_page.setStyle(results.styles);
						this.$refs.extract_page.setMeta(keys_pages[j], results.pages[keys_pages[j]].current_page, results.pages[keys_pages[j]].url_pdf, results.pages[keys_pages[j]].rotate);
						this.items = [];
					}
					results.pages[keys_pages[j]].url_image = this.documents[results.name].url_pdf.replace(/[^\/]*$/, "") + results.name;
					if (results.pages[keys_pages[j]].rotate)
						results.pages[keys_pages[j]].url_image += "_" + results.pages[keys_pages[j]].rotate + "_";
					if (results.pages[keys_pages[j]].current_page < 10)
						results.pages[keys_pages[j]].url_image += "0";
					if (results.pages[keys_pages[j]].current_page < 100)
						results.pages[keys_pages[j]].url_image += "0";
					results.pages[keys_pages[j]].url_image += results.pages[keys_pages[j]].current_page + ".png";
				}

				this.$refs.extract_page.setDocuments(this.documents);

				this.spinner = false;
			}
		},
		mounted: async function () {

			var self = this;

			this.set_name();
			this.$emit("button_start", false);				
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		height:60px;
	}
</style>